const constant = {
}
// 图片访问路径
constant.imgHost = process.env.READ_PLATFORM_PATH
constant.cabp_web_res_img = process.env.READ_PLATFORM_PATH+'/bookimg/'
constant.cabp_web_res_css = process.env.READ_PLATFORM_PATH+'/bookcss/'


constant.categoryList = [
  {id: '01', code: 'ts', text: '图书'},
  {id: '02', code: 'ptts', text: '普通图书'},
  {id: '03', code: 'nj', text: '年鉴'},
  {id: '04', code: 'gjs', text: '条目型工具书'},
  {id: '05', code: 'ksjc', text: '考试教材'},
  {id: '09', code: 'tq', text: '其他图书'},
  {id: '10', code: 'djc', text: '单卷册'},
  {id: '11', code: 'dqqk', text: '单期期刊'},
  {id: '12', code: 'dqlwj', text: '单期论文集'},
  {id: '19', code: 'qtdjc', text: '其他单卷册'},
  {id: '21', code: 'bz', text: '标准'},
  {id: '22', code: 'bzhi', text: '报纸'},
  {id: '30', code: 'ck', text: '课程'},
  {id: '31', code: 'sj', text: '试卷'},
  {id: '32', code: 'xt', text: '习题'},
  {id: '33', code: 'kj', text: '课件'},
  {id: '39', code: 'tqkc', text: '其他课程'},
  {id: '41', code: 'tp', text: '图片'},
  {id: '42', code: 'gs', text: '公式'},
  {id: '43', code: 'dzbg', text: '电子表格'},
  {id: '50', code: 'ysp', text: '音视频'},
  {id: '51', code: 'yp', text: '音频'},
  {id: '52', code: 'sp', text: '视频'},
  {id: '53', code: 'dh', text: '动画'},
  {id: '59', code: 'qtysp', text: '其他音视频'},
  {id: '60', code: 'al', text: '案例'},
  {id: '61', code: 'zlj', text: '资料集'},
  {id: '99', code: 'qt', text: '其他类型'},
  {id: '100', code: 'xxzl', text: '学习资料'},
]
constant.pl_sj = 'sj'
constant.pl_xt = 'xt'
constant.pl_ts = 'ts'
constant.pl_al = 'al'
constant.pl_xxzl = 'xxzl'
constant.pl_ck = 'ck'
// 视频格式
constant.videoFormat = ['AVI', 'WMV', 'MPEG', 'QuickTime', 'RealVideo', 'Flash', 'Mpeg-4']
// 图片格式
constant.imageFormat = ['jpg', 'jpeg', 'png', 'mp', 'tif', 'gif', 'pcx', 'tga', 'exif', 'fpx', 'svg', 'psd', 'cdr', 'pcd', 'dxf', 'ufo', 'eps', 'ai', 'raw', 'WMF', 'webp']

// 平台代码对应的地址
constant.appCodeUrl ={
  'bdks':process.env.PLATFORM_PATH,
  'ctjz':process.env.CTJZ_PLATFORM_PATH
}

export default constant



// WEBPACK FOOTER //
// ./src/api/constant.js